import { render, staticRenderFns } from "./InputPulldown.vue?vue&type=template&id=1d8c771d&scoped=true&lang=pug"
import script from "./InputPulldown.vue?vue&type=script&lang=ts"
export * from "./InputPulldown.vue?vue&type=script&lang=ts"
import style0 from "./InputPulldown.vue?vue&type=style&index=0&id=1d8c771d&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d8c771d",
  null
  
)

export default component.exports